import { forwardRef } from 'react'

import _ from 'lodash'

import Button from '../../components/Button/Button'
import Menu from '../../components/Menu/Menu'

import { useActions } from './withActionTrigger'

const ActionsButton = forwardRef((props, ref) => {
  const { label, isOpen, onOpen, onClose, disabled, ...rest } = props

  const onClick = isOpen ? onClose : onOpen

  return (
    <Button
      $iconRight='▼'
      disabled={disabled}
      onClick={onClick}
      ref={ref}
      {...rest}
    >
      {label || 'Actions'}
    </Button>
  )
})

ActionsButton.displayName = 'ActionsButton'

const ActionsMenu = forwardRef(() => {
  const { actions } = useActions()

  const count = _.size(actions)

  if (count === 0) {
    return null
  }

  if (count === 1) {
    const { label, onClick, disabled } = _.first(actions)
    return (
      <Button disabled={disabled} onClick={onClick}>
        {label}
      </Button>
    )
  }

  const sortedActions = _.orderBy(actions, ['label'], ['asc'])

  const items = _.map(sortedActions, ({ id, label, onClick, disabled }) => (
    <Menu.Item disabled={disabled} key={id} onClick={onClick}>
      {label}
    </Menu.Item>
  ))

  const renderTrigger = ({ isOpen, onOpen, onClose, ref }) => (
    <ActionsButton
      disabled={_.isEmpty(actions)}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      ref={ref}
    />
  )
  return <Menu trigger={renderTrigger}>{items}</Menu>
})

ActionsMenu.displayName = 'ActionsMenu'

export default ActionsMenu
